
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: 'Ana Sayfa', id: 'ana-sayfa' },
    { label: 'Özellikler', id: 'ozellikler' },
    { label: 'Hizmetler', id: 'hizmetler' },
    { label: 'Süreç', id: 'süreç' },
    { label: 'Hakkımızda', id: 'hakkimizda' },
    { label: 'Referanslar', id: 'referanslar' },
    { label: 'Fiyatlar', id: 'fiyatlar' },
    { label: 'İletişim', id: 'iletisim' }
  ];

  const services = [
    'Web Tasarım & Geliştirme',
    'E-Ticaret Çözümleri',
    'Mobil Uygulama Geliştirme',
    'UI/UX Tasarım',
    'SEO & Dijital Pazarlama',
    'Bakım & Destek'
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/3 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-cyan-500/3 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                <div className="flex items-center space-x-3 mb-4">
                  <img 
                    src="https://static.readdy.ai/image/affc4fc5264ff833cc1aa53e66659722/b87eb8ba8acad28110956199bb423d54.png" 
                    alt="AYYILDIZ DİGİTAL Logo" 
                    className="w-16 h-16 object-contain mix-blend-normal"
                    style={{ backgroundColor: 'transparent' }}
                  />
                  <h3 className="text-lg font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-500 bg-clip-text text-transparent">
                    AYYILDIZ DİGİTAL
                  </h3>
                </div>
                <p className="text-gray-300 leading-relaxed">
                  Geleceğin dijital çözümleri ile işletmenizi dijital dünyada öne çıkarıyoruz. 
                  Modern tasarım ve yenilikçi teknolojilerle projelerinizi hayata geçiriyoruz.
                </p>
              </div>

              {/* Social Media */}
              <div>
                <h4 className="text-white font-semibold mb-4">Bizi Takip Edin</h4>
                <div className="flex space-x-3">
                  {[
                    { icon: 'ri-linkedin-fill', href: '#', color: 'hover:text-blue-400 hover:bg-blue-500/20', disabled: true },
                    { icon: 'ri-twitter-fill', href: '#', color: 'hover:text-cyan-400 hover:bg-cyan-500/20', disabled: true },
                    { icon: 'ri-instagram-line', href: '#', color: 'hover:text-pink-400 hover:bg-pink-500/20', disabled: true },
                    { icon: 'ri-facebook-fill', href: '#', color: 'hover:text-blue-500 hover:bg-blue-600/20', disabled: true },
                    { icon: 'ri-youtube-fill', href: '#', color: 'hover:text-red-400 hover:bg-red-500/20', disabled: true }
                  ].map((social, index) => (
                    <div
                      key={index}
                      className={`w-10 h-10 bg-gray-800/30 rounded-lg flex items-center justify-center text-gray-600 cursor-not-allowed opacity-50`}
                    >
                      <i className={social.icon}></i>
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-xs mt-2">Çok yakında aktif olacak</p>
              </div>

            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-6">Hızlı Linkler</h4>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <button
                      onClick={() => scrollToSection(link.id)}
                      className="text-gray-300 hover:text-blue-400 transition-colors duration-300 cursor-pointer group flex items-center"
                    >
                      <i className="ri-arrow-right-s-line mr-1 transition-transform group-hover:translate-x-1"></i>
                      {link.label}
                    </button>
                  </li>
                ))}
                <li>
                  <a
                    href="https://readdy.ai/?origin=logo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 cursor-pointer group flex items-center"
                  >
                    <i className="ri-arrow-right-s-line mr-1 transition-transform group-hover:translate-x-1"></i>
                    Powered by Readdy
                  </a>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-white font-semibold mb-6">Hizmetlerimiz</h4>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index}>
                    <button
                      onClick={() => scrollToSection('hizmetler')}
                      className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer text-left"
                    >
                      {service}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-white font-semibold mb-6">İletişim</h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-400 mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      Şehitler Mahallesi 127. Sokak No:26<br />
                      Salihli/Manisa 45310
                    </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-400 mr-3 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-300 text-sm">0.506 099 39 96</p>
                  </div>
                </div>

                <div className="flex items-center">
                  <i className="ri-mail-line text-blue-400 mr-3 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-300 text-sm">yazilimvewebtasarim@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-time-line text-blue-400 mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-300 text-sm">Pazartesi - Cuma: 09:00 - 16:00</p>
                    <p className="text-gray-300 text-sm">Hafta sonu kapalı</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800/50">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-gray-400 text-sm text-center md:text-left">
                © 2024 AYYILDIZ DİGİTAL. Tüm hakları saklıdır.
              </div>
              
              <div className="flex flex-wrap justify-center md:justify-end space-x-6 text-sm">
                <button className="text-gray-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Gizlilik Politikası
                </button>
                <button className="text-gray-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Kullanım Şartları
                </button>
                <button className="text-gray-400 hover:text-blue-400 transition-colors duration-300 cursor-pointer">
                  Çerez Politikası
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
